// Replace with your request types
export const GET_USER = "GET_USER";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGOUT_USER = "LOGOUT_USER";
